import { useContext } from 'react';
import { TourContext, type TourContextValue } from './tourContext';

/**
 * Access the guided-tour controls (launch a tour, query "seen" state, list the
 * catalogue).
 *
 * Safe to call outside a provider — the context default is inert — so components
 * such as the Help Centre launcher and the shell's "Take a tour" button remain
 * render- and test-safe without mounting the full tour stack.
 */
export function useTours(): TourContextValue {
  return useContext(TourContext);
}
